import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { defaultScreenOptions } from '@bonanza-social/navigation';
import { UploadDocumentsNavigatorParamsList } from './UploadDocumentsNavigator.types';
import UploadDocumentsInfoScreen from '../screens/UploadDocumentsInfoScreen/UploadDocumentsInfoScreen';
import UploadDocumentsScreen from '../screens/UploadDocumentsScreen/UploadDocumentsScreen';

const UploadDocuments =
  createNativeStackNavigator<UploadDocumentsNavigatorParamsList>();

function UploadDocumentsNavigator() {
  return (
    <UploadDocuments.Navigator screenOptions={defaultScreenOptions}>
      <UploadDocuments.Screen
        name="UploadDocumentsInfo"
        component={UploadDocumentsInfoScreen}
      />
      <UploadDocuments.Screen
        name="UploadDocuments"
        component={UploadDocumentsScreen}
      />
    </UploadDocuments.Navigator>
  );
}

export default UploadDocumentsNavigator;
